/**
 * Text for ESC/POS thermal printers. The printer reads one byte per character
 * from its built-in code page, so anything outside plain ASCII (emoji, accents,
 * curly quotes) prints as garbage: "Mango🥭" comes out as "Mango≡ƒÑ¡".
 * Digital receipts (PDF, share) keep the original text.
 */

/** Characters with a readable ASCII stand-in; the rest are dropped. */
const PRINTER_TEXT_REPLACEMENTS: Array<[RegExp, string]> = [
  [/[‘’‚‛′]/g, "'"],
  [/[“”„‟″]/g, '"'],
  [/[‐-―−]/g, '-'],
  [/…/g, '...'],
  [/×/g, 'x'],
  [/€/g, 'EUR'],
  [/£/g, 'GBP'],
  [/ß/g, 'ss'],
  [/Æ/g, 'AE'],
  [/æ/g, 'ae'],
  [/Œ/g, 'OE'],
  [/œ/g, 'oe'],
  [/Ø/g, 'O'],
  [/ø/g, 'o'],
  [/Đ/g, 'D'],
  [/đ/g, 'd'],
  [/Ł/g, 'L'],
  [/ł/g, 'l'],
];

/**
 * Plain ASCII the printer can draw: accents become their base letter
 * ("Café" → "Cafe"), common symbols become ASCII, everything else (emoji,
 * other scripts) is dropped and the spaces left behind are collapsed.
 */
export const toPrinterText = (text: string): string => {
  let value = String(text ?? '').replace(/\s/g, ' ');
  for (const [pattern, replacement] of PRINTER_TEXT_REPLACEMENTS) {
    value = value.replace(pattern, replacement);
  }
  try {
    value = value.normalize('NFKD').replace(/[̀-ͯ]/g, '');
  } catch {
    // No normalize() support: accented letters are dropped below instead.
  }
  return value
    .replace(/[^\x20-\x7E]/g, '')
    .replace(/ {2,}/g, ' ')
    .trim();
};
